import { Model } from "@vuex-orm/core";
import config from "../configs/BuildingOwner";
import Mandate from "./Mandate";
import BuildingLot from "./BuildingLot";
import BuildingOwnerBuildingLot from "./BuildingOwnerBuildingLot";

export default class BuildingOwner extends Model {
  static get entity() {
    return "building_owners";
  }
  static fields() {
    return {
      id: this.attr(null),
      username: this.attr(null),
      password: this.attr(null),
      agency_id: this.attr(null),
      building_id: this.attr(null),
      user_id: this.attr(null),
      number: this.attr(null),
      address: this.attr(null),
      complement: this.attr(null),
      complement2: this.attr(null),
      zipcode: this.attr(null),
      city: this.attr(null),
      country: this.attr(null),
      contact_type: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..
      can_vote: this.number(0),
      gender: this.attr(null),
      entity_type: this.number(1),
      firstname: this.attr(null),
      lastname: this.attr(null),
      phone: this.attr(null),
      email: this.attr(null),
      // EX: one-to-many
      mandates: this.hasMany(Mandate, "building_owner_id"),
      building_lots: this.belongsToMany(
        BuildingLot,
        BuildingOwnerBuildingLot,
        "building_owner_id",
        "building_lot_id"
      ),

      // !!!: HACK: for voting limit rules
      building_owner_building_lots: this.hasMany(BuildingOwnerBuildingLot, "building_owner_id"),
      owner_left: this.attr(null),
      settings: this.attr(null),
      building_asl_id: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
